module.exports = __webpack_public_path__ + "images/assets/ce0677ed384f1519084ef87c1134c1d4.svg";